import { render, staticRenderFns } from "./transactionsByID.vue?vue&type=template&id=82e1e38a&lang=html"
import script from "./transactionsByID.vue?vue&type=script&lang=js"
export * from "./transactionsByID.vue?vue&type=script&lang=js"
import style0 from "./transactionsByID.vue?vue&type=style&index=0&id=82e1e38a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports